import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors';
import { AuthContext } from '../../contexts/auth/Store';
import moment from 'moment';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';

const WalletHistoryCard = () => {
    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [loading, setLoading] = React.useState(false)
    const [history, setHistory] = React.useState(null)

    const loadHistory = () => {
        setLoading(true)
        let form = new FormData()
        form.append('mobile', buyer.phone)
        form.append('model', 'buyer')
        http.post('spend/eyowo_retrieve_history', form, token)
            .then(res => {
                if (res.code === 200 && res?.data?.data?.transactions) {
                    setHistory(res?.data?.data?.transactions)
                }
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                console.warn(err)
            })
    }

    const TransactionDetail = (props) => {
        const { item } = props

        let detail = {
            title: '',
            description: ''
        }

        switch (item.type) {
            case 'bills':
                detail.title = item?.recipient?.metadata?.billtype == 'vtu' ? 'Airtime (VTU)' : 'Bill'
                detail.description = `${item?.recipient?.metadata?.billCustomerID} (${item?.recipient?.metadata?.billerName})`
                break;
            case 'PHONE_TRANSFER':
                detail.title = 'Phone Transfer'
                detail.description = `${item?.recipient?.eyowo?.mobile}`
                break;
            case 'BANK_TRANSFER':
                detail.title = 'Bank Transfer'
                detail.description = `${item?.recipient?.bank?.accountName} (${item?.recipient?.bank?.accountNumber})`
                break;
            case 'BVN_CHECK':
                detail.title = 'BVN Check'
                detail.description = `BVN: ${item?.recipient?.metadata?.checkedBVN}`
                break;

            default:
                break;
        }

        return <View style={{ flexGrow: 1, maxWidth: '65%' }}>
            <Text
                numberOfLines={1}
                style={[
                    FontStyles.normal,
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.dark,
                    {
                        textAlign: 'left',
                        marginLeft: 8,
                    }
                ]}
            >{detail.title}</Text>
            <Text
                numberOfLines={1}
                style={[
                    FontStyles.normal,
                    FontStyles.size13,
                    FontStyles.lh15,
                    FontStyles.gray,
                    {
                        textAlign: 'left',
                        marginTop: 5,
                        marginLeft: 8,
                    }
                ]}
            >{detail.description}</Text>
        </View>
    }

    React.useEffect(() => {
        loadHistory()
        return () => { }
    }, [])

    return <View style={styles.container}>
        {/* card */}
        <View style={styles.card}>
            {/* card header */}
            <View style={styles.cardHeader}>
                <Text style={[
                    styles.cardHeaderTitle,
                    FontStyles.normal,
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.gray,
                    {
                        flexGrow: 1
                    }
                ]}>Transactions Log</Text>
                {/* <Text style={[
                    styles.historyBadge,
                    FontStyles.size14,
                    FontStyles.lh16,
                ]}>This Month</Text> */}
                {/* <StyledIcon iconName="ios-arrow-down" iconColor={Colors.greyColor} iconOnly size={14} /> */}
            </View>

            {/* card body */}
            <View style={styles.listContainer}>
                {/* fund account */}
                {loading
                    // ? <ActivityIndicator size={24} color={Colors.greyColor} />
                    ? <View style={styles.listItem}>
                        <View style={styles.virtualImage}></View>
                        <View style={{ flexGrow: 1 }}>
                            <Text
                                numberOfLines={1}
                                style={[
                                    FontStyles.normal,
                                    FontStyles.size14,
                                    FontStyles.lh16,
                                    {
                                        textAlign: 'left',
                                        marginLeft: 8,
                                        marginRight: '20%',
                                        color: Colors.shades._6,
                                        backgroundColor: Colors.shades._6
                                    }
                                ]}
                            >History Item Title</Text>
                            <Text
                                numberOfLines={1}
                                style={[
                                    FontStyles.normal,
                                    FontStyles.size13,
                                    FontStyles.lh15,
                                    {
                                        textAlign: 'left',
                                        marginTop: 5,
                                        marginLeft: 8,
                                        marginRight: '10%',
                                        color: Colors.shades._6,
                                        backgroundColor: Colors.shades._6
                                    }
                                ]}
                            >History item description</Text>
                        </View>
                        <View>
                            <Text
                                style={[
                                    FontStyles.normal,
                                    FontStyles.size14,
                                    FontStyles.lh16,
                                    {
                                        textAlign: 'right',
                                        color: Colors.shades._6,
                                        backgroundColor: Colors.shades._6
                                    }
                                ]}
                            >- {formatCurrency(5052/100)}</Text>
                            <Text
                                style={[
                                    FontStyles.normal,
                                    FontStyles.size13,
                                    FontStyles.lh15,
                                    {
                                        textAlign: 'right',
                                        marginTop: 5,
                                        color: Colors.shades._6,
                                        backgroundColor: Colors.shades._6
                                    }
                                ]}
                            >Aug 16</Text>
                        </View>
                    </View>
                    : history?.length
                        ? history.map(item => <View key={item.reference} style={styles.listItem}>
                            <View style={styles.virtualImage}></View>
                            <TransactionDetail item={item} />
                            <View>
                                <Text
                                    style={[
                                        FontStyles.normal,
                                        FontStyles.size14,
                                        FontStyles.lh16,
                                        {
                                            textAlign: 'right',
                                            color: Colors.dangerText
                                        }
                                    ]}
                                >{formatCurrency(item.amount/100)}</Text>
                                <Text
                                    style={[
                                        FontStyles.normal,
                                        FontStyles.size13,
                                        FontStyles.lh15,
                                        FontStyles.gray,
                                        {
                                            textAlign: 'right',
                                            marginTop: 5
                                        }
                                    ]}
                                >{moment(item.created_at).format('MMM DD YYYY')}</Text>
                            </View>
                        </View>)
                        : <Text style={[FontStyles.gray, FontStyles.size16, FontStyles.lh22, { textAlign: 'center', padding: 8 }]}>No history</Text>
                }

            </View>
        </View>
    </View >
}

export default WalletHistoryCard

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingTop: 16,
    },
    card: {
        backgroundColor: Colors.whiteColor,
        overflow: 'hidden',
        borderRadius: 6,
        borderColor: Colors.borderColor,
        borderWidth: 1,
        borderBottomWidth: 3,
        borderStyle: 'solid',
    },
    cardHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderBottomWidth: 1,
        borderColor: Colors.borderColor,
        borderStyle: 'solid',
        minHeight: 44
    },
    // cardHeaderTitle: {},
    historyBadge: {
        color: Colors.greyColor,
        borderRadius: 4,
        paddingHorizontal: 8,
        paddingVertical: 6,
    },
    listContainer: {
        backgroundColor: Colors.whiteColor,
        paddingVertical: 10,
        paddingHorizontal: 8,
    },
    listItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 10,
    },
    virtualImage: {
        width: 42,
        height: undefined,
        aspectRatio: 1,
        backgroundColor: Colors.shades._6,
        borderRadius: 24
    }
})